import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=1a10c2c3&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=ts"
export * from "./AppContent.vue?vue&type=script&lang=ts"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=1a10c2c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10c2c3",
  null
  
)

export default component.exports